import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import constant from './modules/constant';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    constant
  }
})
